import authHeader from "./auth-header";
import API_URL from "@/globals/api";
import axiosInstance from "./api";

class LogService {
  lastUsed(email) {
    return axiosInstance.post(`${API_URL}/logs/update`, {
      email: email,
      timestamp: Date.now()
    }, {
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
    });
  }
}

export default new LogService();
